import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';
import { FormDynamic } from '../../core/resources/FormDynamic';

import "./InfoSend.scss"
import { Utils } from '../../core/Utils';
interface PropsDynamicForm {
    form?: FormDynamic;
    open:boolean;
    title:string
    handleClose:()=>void
    handleSuccess:()=>void
  }



  
  export const InfoSend: React.FC<PropsDynamicForm> = (props) => {
       const{open,title,handleSuccess,handleClose} = props

  
       

        return <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {!Utils.isTelegram() && 
              <div className="w-100 text-center container-info" >
                <p><b>ATTENZIONE!</b> Verrai riportato su whatsapp con un messaggio contenente i tuoi <b>DATI CODIFICATI.</b></p>
                <p>Ti basterà inviare il messaggio <b>SENZA EFFETTUARE ALCUNA MODIFICA</b>, qui sotto puoi vedere un esempio:</p>
                <img src="./assets/images/code.jpeg" alt="" />
                <p className="mt-2">Questa procedura ci permette di registrare le informazioni che ci hai fornito nel modo più sicuro e riservato possibile.</p>
              </div> }
               {Utils.isTelegram() && <div className="w-100 text-center container-info" ><p><b>ATTENZIONE!</b> Verrai riportato su Telegram App con in memoria un messaggio contenente i tuoi <b>DATI CODIFICATI.</b></p>
                          
               <video id='videoPlayer'  autoPlay={true} muted playsInline  loop controls={false}>
                  <source src="./assets/pastecode.mp4" type="video/mp4"/>
                  <img src="./assets/images/tl-code.jpeg" className="tl" alt="" />
                </video>
              
                <p className='mt-2'><b>Incolla nell'aria di testo ed invia</b></p>
              </div>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Chiudi
          </Button>
          <Button onClick={handleSuccess} color="primary" >
             {!Utils.isTelegram()?  <>Apri Whatsapp</>  : <>Apri Telegram</>}
          </Button>
        </DialogActions>
      </Dialog>
        
     
  }